export { default } from './UnscoredCategoryPageTypesSection'
